import type { RequestStatusT } from "../domain/types/requestStatus.types";

import { REQUEST_STATUS } from "../constants/status";

const UPDATABLE_STATUSES = new Set<RequestStatusT>([
  REQUEST_STATUS.PENDING,
  REQUEST_STATUS.APPROVED,
]);

export const canUpdateStatus = (currentStatus: RequestStatusT) =>
  UPDATABLE_STATUSES.has(currentStatus);
